import { CustomTextField, VerticalForm, CustomTextArea } from '../../../common/components';

const GeneralDataSection = ({ formData, errors, onChange }) => {
  return (
    <VerticalForm withBorder={false}>
      <CustomTextField
        label="Nombre"
        value={formData.name}
        onChange={(event) => onChange('name', event.target.value)}
        error={Boolean(errors.name)}
        helperText={errors.name}
        placeholder="Ingrese el nombre del concepto"
        required
        inputProps={{ maxLength: 150 }}
        fullWidth
        size="medium"
      />

      <CustomTextField
        label="Código"
        value={formData.code}
        onChange={(event) => onChange('code', event.target.value)}
        error={Boolean(errors.code)}
        helperText={errors.code || 'Opcional. Se recomienda usar un código único en mayúsculas.'}
        placeholder="Ej: COBROS_CLIENTES"
        inputProps={{ maxLength: 50 }}
        fullWidth
        size="medium"
      />

      <CustomTextArea
        label="Descripción"
        value={formData.description}
        onChange={(event) => onChange('description', event.target.value)}
        error={Boolean(errors.description)}
        helperText={errors.description}
        placeholder="Descripción breve del uso del concepto"
        inputProps={{ maxLength: 255 }}
        fullWidth
        multiline
        minRows={3}
        size="medium"
      />
    </VerticalForm>
  );
};

export default GeneralDataSection;
